module.exports = __webpack_public_path__ + "static/news2-pic4-93816392dde2f70c661bd32e6c52d5f8.jpg";